// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawable-video-player__player-canvas-wrapper{position:relative}\n", ""]);
// Exports
module.exports = exports;
